import CookieService from "./cookie-service";

export default CookieService;